import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '..'

const initialState = {
  id: 'global-toast',
  message: '',
  isSuccess: true,
  isShown: false,
}

const globalToastSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    showGlobalToast(
      state,
      action: PayloadAction<{ message: string; isSuccess: boolean }>,
    ) {
      state.message = action.payload.message
      state.isSuccess = action.payload.isSuccess
      state.isShown = true
    },
    closeGlobalToast(state) {
      state.isShown = false
      state.message = ''
    },
  },
})

export const { showGlobalToast, closeGlobalToast } = globalToastSlice.actions
export default globalToastSlice.reducer

export const selectGlobalToastState = (state: RootState) => state.globalToast
